import PropTypes from 'prop-types';
import Icon from './Icon';

const Menu = (props) => {
  const { stroke, strokeWidth, strokeLinecap, strokeLinejoin } = props;
  return (
    <Icon {...props}>
      <path
        d="M3 12H21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap={strokeLinecap}
        strokeLinejoin={strokeLinejoin}
      />
      <path
        d="M3 6H21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap={strokeLinecap}
        strokeLinejoin={strokeLinejoin}
      />
      <path
        d="M3 18H21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap={strokeLinecap}
        strokeLinejoin={strokeLinejoin}
      />
    </Icon>
  );
};

Menu.propTypes = {
  stroke: PropTypes.string,
  strokeWidth: PropTypes.string,
  strokeLinecap: PropTypes.string,
  strokeLinejoin: PropTypes.string
};
Menu.defaultProps = {
  stroke: 'var(--color-text-primary)',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};
export default Menu;
